import { useEffect, useState } from 'react';
import { getFileName } from '../utils/FileNameUtils';

function EntityFileUploadField({
  fileKey,
  existingValue,
  clearFieldName,
  label,
  selectedFile,
  isChecked,
  imageUrl,
  onChange,
  onClear,
}) {
  const selected = selectedFile[fileKey];
  const displayName = selected
    ? selected.name
    : (existingValue ? getFileName(existingValue) : null);
  const isMarkedClear = Boolean(isChecked[clearFieldName]);
  const hasFile = Boolean(displayName) && !isMarkedClear;
  const existingFileUrl = existingValue && imageUrl ? `${imageUrl}${existingValue}` : null;
  const canClear = Boolean(existingValue || selected);
  const [existingStatus, setExistingStatus] = useState('idle');
  const inputId = `${fileKey}_upload`;

  useEffect(() => {
    if (!existingFileUrl || selected) {
      setExistingStatus('idle');
      return undefined;
    }
    let cancelled = false;
    const img = new Image();
    img.onload = () => {
      if (!cancelled) {
        setExistingStatus('ok');
      }
    };
    img.onerror = () => {
      if (!cancelled) {
        setExistingStatus('missing');
      }
    };
    img.src = existingFileUrl;
    return () => {
      cancelled = true;
    };
  }, [existingFileUrl, selected]);

  const clearStatusMessage = isMarkedClear
    ? (existingValue ? 'Marked for removal on update' : 'No file uploaded')
    : null;

  let statusContent = displayName || 'No file uploaded';
  if (clearStatusMessage) {
    statusContent = clearStatusMessage;
  } else if (hasFile && existingFileUrl && !selected && existingStatus === 'ok') {
    statusContent = (
      <a target="_blank" rel="noopener noreferrer" href={existingFileUrl}>{displayName}</a>
    );
  } else if (hasFile && existingFileUrl && !selected && existingStatus === 'missing') {
    statusContent = `${displayName} (missing — upload again)`;
  }

  return (
    <>
      <label className="form-group col-sm-4 text-right">{label}</label>
      <div className="col-sm-7 company-file-upload-row">
        <div className="company-file-upload company-file-upload-grow">
          <input
            type="file"
            id={inputId}
            name={fileKey}
            onChange={onChange}
            className="company-file-upload-input"
          />
          <label htmlFor={inputId} className="company-file-upload-btn">Choose File</label>
          <span className={`company-file-upload-status ${hasFile ? 'has-file' : ''}`}>
            {statusContent}
          </span>
        </div>
        {canClear ? (
          <div className="company-file-clear">
            <input
              type="checkbox"
              id={clearFieldName}
              name={clearFieldName}
              checked={isChecked[clearFieldName] || false}
              onChange={onClear}
            />
            <label htmlFor={clearFieldName}>Clear</label>
          </div>
        ) : null}
      </div>
      <br />
    </>
  );
}

export default EntityFileUploadField;
